import {
  FETCH_ALGOS_CONFIG_REQUEST,
  FETCH_ALGOS_CONFIG_SUCCESS,
  FETCH_ALGOS_CONFIG_FAILURE,
} from '../constants/ActionTypes';

const algosDayWise = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_ALGOS_CONFIG_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_CONFIG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGOS_CONFIG_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

export default algosDayWise;
